<script>
  import { v4 as uuidv4 } from 'uuid'

  export let video

  const ID = uuidv4()
  const ID_HEADLINE = `${ID}-headline`
  const ID_CONTENT = `${ID}-content`

  let showVideo = false
  const src = `https://www.youtube.com/embed/${video.id}`
</script>

<article class="video-item">
  <h2
    class="video-item__headline"
    id={ID_HEADLINE}
  >{ video.title }</h2>
  {#if video.description}
    <p class="video-item__description">{ video.description }</p>
  {/if}
  <button
    aria-expanded={showVideo.toString()}
    aria-controls={ID_CONTENT}
    class="video-item__toggle button--text button--icon {showVideo ? '-closed-eye' : '-open-eye'}"
    on:click={() => showVideo = !showVideo}
  >
    { showVideo ? 'Video ausblenden' : 'Video anzeigen' }
  </button>
  {#if showVideo}
    <section class="video-item__video-container" id={ID_CONTENT}>
      <iframe
        {src}
        title={video.title}
        width="560"
        height="315"
        frameborder="0"
        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
    </section>
  {/if}
</article>

<style>
.video-item {
  max-width: 55ch;
  margin-bottom: 2rem;
}

.video-item__headline {
  text-transform: uppercase;
  letter-spacing: 0.05em;
  word-spacing: 0.05em;
}

.video-item__description {
  font-size: smaller;
}

.video-item__toggle {
  margin-top: 0.5rem;
}

.video-item__video-container {
  margin-top: 0.5rem;
  padding-bottom: calc(100% / (16 / 9));
  position: relative;
}

.video-item__video-container > * {
  height: 100%;
  position: absolute;
  width: 100%;
}
</style>